module.exports = __webpack_public_path__ + "static/media/kayttajaryhmat.3696c918.svg";